var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('div',[_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"cursor-pointer",attrs:{"src":_vm.getPhoto,"alt":""}})]):_c('v-skeleton-loader',{staticClass:"h-100 w-100",attrs:{"type":"image"}})
}
var staticRenderFns = []

export { render, staticRenderFns }